<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fas fa-calendar-week mr-2"></i>{{ $t('general.visitas') }}</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" title="Pantalla completa" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>
            </div>
        </div>
        <div class="card-body p-0 table-responsive">
            <br v-if="visitas.length == 1">
            <div style="height: 150px; position: relative;" class="loading-spinner" v-if="loading">
                <div style="position: absolute; inset: 0; margin: auto; height: fit-content; width: fit-content">
                    <i class="fas fa-spinner fa-spin"></i> Cargando...
                </div>
            </div>

            <table v-else class="table table-sm">
                <thead>
                    <tr>
                        <th>info</th>
                        <th>{{ $t('general.fecha') }}</th>
                        <th>Siniestrado</th>
                        <th width="25%">{{ $t('general.operario') }}</th>
                        <th>{{ $t('general.especialidad') }}</th>
                        <th>{{ $t('general.estado') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-for="visita in visitas" :key="visita.visita.idvisitador">
                    <tr v-if="visita.visita.cita_temporal > 0">
                        <td><i @mouseover="infoevento($event, visita.visita.datos.descripcion_visitadores)"
                                @mouseleave="closeInfo()" class="fa fa-info-circle" aria-hidden="true"></i></td>
                        <td>{{ formato(visita.visita.fecha) }} {{ visita.visita.hora.split(':')[0] }}:{{
                            visita.visita.hora.split(':')[1] }}</td>
                        <td v-if="visita.visita.nombre_cliente" :title="visita.visita.nombre_cliente"><span>{{
                                visita.visita.nombre_cliente.substring(0, 12) + '...' }}</span></td>
                        <td v-else>&nbsp;</td>
                        <td><i style="cursor: pointer;" @click="operarioPulsado(visita)"
                                class="fas fa-user-cog mr-2"></i><span style="width: fit-content"
                                @mouseover="toggle($event, visita)" @mouseleave="closeToggle()">{{
                                visita.visita.nombre_operario }}</span></td>
                        <td>{{ visita.visita.nombre_especialidad }}</td>
                        <td>
                            <span class="badge bg-orange">Reserva</span>
                        </td>
                        <td>
                            <div class="d-flex flex-wrap">
                                <div class="btn-group">
                                    <button v-if="visita.visita.realizado_operario == ''"
                                        @click.stop="eliminarvisita(visita)" title="Eliminar visita"
                                        class="btn btn-default ">
                                        <i class="fas fa-times" style="color:red;"></i>
                                    </button>

                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else @click="mostrarvisita = true; handleRowClick($event, visita.visita.idvisitador)"
                        @mouseover="visitagen = visita;" :data-expanded="visita.visita.idvisitador === expandidaId">
                        <td><i @mouseover="infoevento($event, visita.visita.datos.descripcion_visitadores)"
                                @mouseleave="closeInfo()" class="fa fa-info-circle" aria-hidden="true"></i></td>
                        <td>{{ formato(visita.visita.fecha) }} {{ visita.visita.hora.split(':')[0] }}:{{
                            visita.visita.hora.split(':')[1] }}</td>
                        <td v-if="visita.visita.nombre_cliente" :title="visita.visita.nombre_cliente"><span>{{
                                visita.visita.nombre_cliente.substring(0, 12) + '...' }}</span></td>
                        <td v-else>&nbsp;</td>
                        <td><i style="cursor: pointer;" @click="operarioPulsado(visita)"
                                class="fas fa-user-cog mr-2"></i><span style="width: fit-content"
                                @mouseover="toggle($event, visita)" @mouseleave="closeToggle()">{{
                                visita.visita.nombre_operario }}</span></td>
                        <td>{{ visita.visita.nombre_especialidad }}</td>
                        <td>
                            <span v-if="visita.visita.confirmar=='1'" class="badge bg-danger">Por confirmar</span>
                            <span v-else-if="visita.visita.realizado_operario == ''"
                                class="badge bg-warning">Activa</span>
                            <span v-else class="badge bg-secondary">Finalizada</span>&nbsp;
                            <span v-if="visita.tiene_firma" class="badge bg-teal">Firmada</span>
                        </td>
                        <td v-if="mostrarBotones[visita.visita.idvisitador]">
                            <div class="d-flex flex-wrap">
                                <div class="btn-group">
                                    <button v-if="visita.visita.realizado_operario == '' || visita.eliminable"
                                        @click.stop="eliminarvisita(visita)" title="Eliminar visita"
                                        class="btn btn-default ">
                                        <i class="fas fa-times" style="color:red;"></i>
                                    </button>
                                    <button
                                        v-if="visita.visita.realizado_operario == '' || visita.visita.confirmar!='1'"
                                        type="button" @click="chat(visita)" title="Chat" class="btn btn-default ">
                                        <i class="far fa-comment-dots"></i>
                                        <span style="margin-top: 20px;margin-left: -5px;" v-if="visita.chats > 0"
                                            class="position-absolute bottom-0 start-0 translate-middle badge rounded-pill bg-danger">
                                            {{ visita.chats }}
                                        </span>
                                    </button>
                                    <button type="button" v-if="visita.visita.confirmar=='1'"
                                        @click="mostrarConfirmar(visita)" title="Confirmar Visita"
                                        class="btn btn-default ">
                                        <i class="fas fa-align-justify"></i>
                                    </button>

                                    <button v-if="mostrarPresupuesto" type="button"
                                        @click.stop="mostrarpresupuestos(visita)" class="btn btn-default "
                                        :style="'background:' + colorbotonpresup" title="Presupuesto">
                                        <i class="far fa-folder-open"></i>
                                    </button>
                                    <button type="button" v-if="visita.modificable == '1'"
                                        :style="'background:' + colorbotondos" @click.stop="mostrarEditar(visita)"
                                        class="btn btn-default " title="Modificar visita">
                                        <i class="far fa-edit"></i>
                                    </button>
                                    <button v-if="visita.visita.realizado_operario == ''" type="button"
                                        class="btn btn-default " @click="mostrarFinalizarBtn(visita)"
                                        :style="'background:' + colorbotoncuatro" title="Finalizar Visita">
                                        <i class="fas fa-check"></i>
                                    </button>
                                    <div class="btn-group open" style="width: 60px; margin: 0;">
                                        <button type="button" class="btn btn-default dropdown-toggle"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            aria-controls="dropdownMenu1">
                                            <i class="fas fa-share-square"></i>
                                        </button>
                                        <ul id="dropdownMenu1" class="dropdown-menu" aria-labelledby="dropdownMenu1">
                                            <li class="dropdown-item"><a href="#"
                                                    @click.stop="parteoperarioemail(visita)">{{
                                                    $t('general.enviarfichaemail') }}</a></li>
                                            <li class="dropdown-divider"></li>
                                            <li class="dropdown-item"><a href="#" @click.stop="smsoperario(visita)">{{
                                                    $t('general.smsaloperario') }}</a></li>
                                            <li class="dropdown-item"><a href="#" @click.stop="smsasegurado(visita)">{{
                                                    $t('general.smsalasegurado') }}</a></li>
                                            <li class="dropdown-item" v-if="ste"><a href="#"
                                                    @click="steasegurado(visita)">{{ $t('general.firmasteemail') }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="visita.fichas_operario.MULTIASISTENCIA_WS" class="btn-group open"
                                        style="width: 50px; margin: 0;">
                                        <button type="button" class="btn btn-default dropdown-toggle"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            aria-controls="dropdownMenu2">
                                            <i class="far fa-file"></i>
                                        </button>
                                        <ul id="dropdownMenu2" @click.stop="" class="dropdown-menu"
                                            aria-labelledby="dropdownMenu2">
                                            <li v-if="visita.tiene_firma" class="dropdown-item"><a href="#"
                                                    @click.stop="abrirventana(visita)">Parte Genérico</a></li>
                                            <li v-else class="dropdown-item"><a href="#"
                                                    @click.stop="abrirventana(visita)">Parte Genérico</a></li>
                                            <li class="dropdown-item"><a href="#"
                                                    @click.stop="multi1(visita)">Multiasistencia 1</a></li>
                                            <li class="dropdown-item"><a href="#"
                                                    @click.stop="multi2(visita)">Multiasistencia 2</a></li>
                                            <li class="dropdown-item"><a href="#"
                                                    @click.stop="multi3(visita)">Multiasistencia 3</a></li>
                                        </ul>
                                    </div>
                                    <div v-else-if="visita.fichas_operario.MAPFRE" class="btn-group open"
                                        style="width: 50px; margin: 0;">
                                        <button type="button" class="btn btn-default dropdown-toggle"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            aria-controls="dropdownMenu2">
                                            <i class="far fa-file"></i>
                                        </button>
                                        <ul id="dropdownMenu2" @click.stop="" class="dropdown-menu"
                                            aria-labelledby="dropdownMenu2">
                                            <li class="dropdown-item"><a href="#"
                                                    @click.stop="abrirventana(visita)">Parte Genérico</a></li>
                                            <li class="dropdown-item"><a href="#" @click.stop="mapf(visita)">Mapfre</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <button v-else type="button" class="btn btn-default "
                                        @click.stop='abrirventana(visita)' title="Parte Genérico">
                                        <i v-if="visita.tiene_firma" class="fas fa-file-signature"></i>
                                        <i v-else class="far fa-file"></i>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="mostrarvisita==true && visita.visita.cita_temporal != 1 && visita.visita.cita_temporal != 2"
                        v-show="visita.visita.idvisitador === expandidaId" class="expandable-body">
                        <td colspan="7">
                            <servicio-datos-visitas-visita @email="email" @recargar="obtenerVisitas"
                                @actualizar="actualizar" v-if="mostrarvisita==true" :visita="visita"
                                :servicio="servicio" :id="id" />
                        </td>
                    </tr>
                    <form :id="visita.visita.idvisitador" method="get" :action="urlchat" target="TheWindow">
                        <input type="hidden" name="vista" value="vista_chats" />
                        <input type="hidden" name="destino_chat" :value="visita.visita.operarios_idoperario" />
                        <input type="hidden" name="id_visita" :value="visita.visita.idvisitador" />
                        <input type="hidden" name="id_servicio" :value="id" />
                    </form>
                </tbody>
                <Dialog :style="{ width: '50rem' }" header="Finalizar visita" v-model:visible="mostrarFinalizar"
                    @update:visible="mostrarFinalizar = false">
                    <div style="display: flex; flex-direction: column; align-items: center; ">
                        <h5>Trabajos realizados</h5>
                        <textarea v-model="trabajosRealizados" class="form-control" id="realizados" rows="4"
                            style="width: 70%;"></textarea>
                        <h5 style="margin-top: 10px;">Trabajos pendientes</h5>
                        <textarea v-model="trabajosPendientes" class="form-control" id="pendientes" rows="4"
                            style="width: 70%;"></textarea>
                        <button class="btn btn-sm btn-light" style="border: 1px solid grey;margin-top: 20px"
                            @click="finalizarvisita()">Finalizar</button>
                    </div>
                </Dialog>
                <Dialog :style="{ width: '35rem' }" header="Eliminar cita" v-model:visible="mostrarMotivoEliminar"
                    @update:visible="mostrarMotivoEliminar = false">
                    <div style="display: flex; flex-direction: column;">
                        <p style="margin-bottom: 5px;">¿Desea eliminar esta cita?</p>
                        <p><b>{{ textoVisitaEliminar }}</b></p>
                        <h5 style="margin-top: 10px;">Motivo</h5>
                        <textarea v-model="motivoEliminar" class="form-control" rows="3"></textarea>
                        <small v-if="errorMotivoEliminar" style="color:red">El motivo es obligatorio</small>
                        <button class="btn btn-sm btn-light" style="border: 1px solid grey;margin-top: 20px"
                            @click="eliminarVisitaMotivo()">Eliminar</button>
                    </div>
                </Dialog>
            </table>
            <br v-if="visitas.length == 1">
            <br v-if="visitas.length == 1">

        </div>
    </div>
    <visita-editar :idservicio="id" :idvisita="visitaaeditar.visita.idvisitador" :visita="visitaaeditar"
        :servicio="servicio" :visitagen="visitagen" />
    <visita-confirmar @actualizar="actualizar" v-if="visitaAConfirmar" :idservicio="id"
        :idvisita="visitaAConfirmar.visita.idvisitador" :visita="visitaAConfirmar" />
    <OverlayPanel ref="op" style="width: 600px;">
        <div
            style="display: grid; justify-content: space-around; grid-template-columns: repeat(3, 1fr); row-gap: 10px;">
            <div v-for="archivos in visitaamostrar.archivosprev" :key="archivos" style="justify-content: center;">
                <div style="display: flex; justify-content: center;" v-if="archivos.image==''">
                    <i class="fas fa-file fa-8x"></i>
                </div>
                <div style="display: flex; justify-content: center;" v-if="archivos.propiedad_cliente != 0">
                    <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga'
                        style="border: 5px solid goldenrod;" width="100" preview :alt="archivos.descripcion" />
                    <Image v-if="urlglobal == 'null.pwgs.app'"
                        :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" + id'
                        style="border: 5px solid goldenrod;" width="100" preview :alt="archivos.descripcion" />
                </div>
                <div style="display: flex; justify-content: center;" v-else>
                    <Image v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga' width="100" preview
                        :alt="archivos.descripcion" />
                    <Image v-if="urlglobal == 'null.pwgs.app'"
                        :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" + id'
                        width="100" preview :alt="archivos.descripcion" />
                </div>
            </div>
        </div>
        <div style="margin-top: 10px;" v-if="prevcortada">
            <p style="margin: 0; font-weight: bold">Para ver todas las imágenes abra la visita.</p>
        </div>
    </OverlayPanel>
    <OverlayPanel ref="opdos">
        <div class="row">
            <p v-html="infoamostrar"></p>
        </div>
    </OverlayPanel>
</template>

<script>
import visitaeditar from './visita_editar_general.vue';
import OverlayPanel from 'primevue/overlaypanel';
import { PwgsApi } from '../../../../../services/PwgsApi';
import Image from 'primevue/image';
import serviciodatosvisitasvisita from './visita_datos.vue';
import visitaconfirmar from './visita_confirmar.vue'
export default {
    props: ['id', 'servicio', 'perjudicados', 'asegurado','cargaseccion'],
    components: {
        'servicio-datos-visitas-visita': serviciodatosvisitasvisita,
        OverlayPanel, Image,
        'visita-editar': visitaeditar,
        'visita-confirmar': visitaconfirmar,
    },
    data() {
        return {
            prevcortada:false,
            visibleConfirmar:false,
            trabajosRealizados:'',
            trabajosPendientes:'',
            visitaAMostrar:'',
            mostrarFinalizar: false,
            visitaaeditar:{
                "visita":{
                    "idvisitador":"1"
                }
            },
            visitaAConfirmar:null,
            visitagen:'',
            urlglobal:'',
            mostrarBotones:[],
            ste:false,
            visitas: [],
            visitaamostrar: '',
            infoamostrar: '',
            visible: false,
            mostrarvisita:false,
            expandidaId: null, // Para guardar el ID de la visita expandida
            loading: true,
            urlapu: localStorage.getItem('direccion'),
            urlchat: "https://" + localStorage.getItem('direccion') + "/modulos/chat/panel.php",
            mostrarMotivoEliminar: false,
            motivoEliminar: '',
            errorMotivoEliminar: false,
            visitaEliminar: null,
            textoVisitaEliminar: '',
        };
    },
    methods: {
        chat(vis) {
            this.urlchat = "https://" + this.urlapu + "/modulos/chat/panel.php";
            window.open('', 'TheWindow');
            document.getElementById(vis.visita.idvisitador).submit();
        },
        email(id){
            this.$emit('email', id);
        },
        operarioPulsado(visita){       
            var idoper = visita.visita.operarios_idoperario;
            this.$router.push({
                name: 'Operario',
                params: {
                    id: idoper
                }
            });
        },
        mostrarConfirmar(visita){
            this.visibleConfirmar = true;
            this.visitaAConfirmar = visita;
        },
        actualizar(){
            this.$emit('actualizar');
        },
        mostrarFinalizarBtn(visita){
            this.visitaAMostrar = visita;
            this.trabajosRealizados = '';
            this.trabajosPendientes = '';
            this.mostrarFinalizar = true;
        },
        async comprobarSe(){
            const api = new PwgsApi();            
            const se = await api.get('/servicios/'+this.id+'/comunicaciones-ste');
            if(se.comunicaciones==1){
                this.ste = true;
            }
        },
        async comprobarChats() {
            const api = new PwgsApi();
            let aux = await api.get('chat-pwgs?id_servicio=' + this.$props.id);
            let chatsservicio = aux.datos;
            console.log("chatsservicio", chatsservicio);
            for (let i = 0; i < this.visitas.length; i++) {
                this.visitas[i].chats = 0;
                for (let j = 0; j < chatsservicio.length; j++) {
                    if (this.visitas[i].visita.idvisitador == chatsservicio[j].visitadores_idvisitador) {
                        this.visitas[i].chats++;
                    }
                }
            }
            console.log("visitas", this.visitas);
        },
        async finalizarvisita() {
            const visita = this.visitaAMostrar;
            const api = new PwgsApi();
            if(this.trabajosRealizados == ''){
                alert("Debe rellenar los trabajos realizados");
                return;
            }
            const body = {'trabajos_realizados_cita': this.trabajosRealizados, 'trabajos_pendientes_cita': this.trabajosPendientes};            
            try{
                await api.put('planning-pwgs/'+this.$props.id+'/finalizar-visita/'+visita.visita.idvisitador, body);
                this.mostrarFinalizar = false;
                this.obtenerVisitas(this.$props.id);
            }catch(e){
                alert(e);
                console.error('error',e);
            }
        },
        async smsoperario(visita) {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-operario/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-sms-operario/" + visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al operario correctamente', life: 2000 });

            }
             catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async smsasegurado(visita) {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-asegurado/:id_visita
            const api = new PwgsApi();
            try {
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-sms-asegurado/" + visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al asegurado correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async steasegurado(visita) {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ste-firma/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-ste-firma/" + visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Ste enviado correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async parteoperarioemail(visita) {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ficha-operario/:id_visita
            const api = new PwgsApi();
            await api.put("planning-pwgs/" + this.$props.id + "/enviar-ficha-operario/" + visita.visita.idvisitador);
            this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Enviada correctamente', life: 2000 });
        },
        mostrarEditar(visita) {
            this.visitaaeditar = visita;
            this.visible = true;
        },
        toggleExpand(idvisitador) {
            this.expandidaId = this.expandidaId === idvisitador ? null : idvisitador;
            for(let btn of Object.keys(this.mostrarBotones)){
                if(idvisitador == btn){
                //nada
                }else{
                    this.mostrarBotones[btn] = true;
                }
            }
            this.mostrarBotones[idvisitador] = !this.mostrarBotones[idvisitador];
        },
        handleRowClick(event, id) {
            if (!event.target.closest('.btn-group') && !event.target.closest('.dropdown-menu')) {
                this.toggleExpand(id);
            }
        },
        mostrarpresupuestos() {
            this.$parent.$parent.togglepresupuestos();
            if (this.$parent.$parent.presupuestos == false) { this.colorbotonpresup = ''; }
            if (this.$parent.$parent.presupuestos == true) { this.colorbotonpresup = 'green'; }
        },
        async obtenerVisitas(id, expandidaId = null) {
            this.visitas = [];
            // Obtiene visitas del servicio con el ID dado
            const api = new PwgsApi();
            try{
                this.visitas = await api.get('servicios/' + id + '/visitas');

            }
            catch(error){
                console.log("error",error);
            }
            if(this.visitas){
            this.visitas.sort((a, b) => parseInt(a.visita.fecha_entera_unix_visita) - parseInt(b.visita.fecha_entera_unix_visita));
            this.expandidaId = expandidaId; // Establece la visita a expandir si se proporciona
            for(let visi of this.visitas){
                this.mostrarBotones[visi.visita.idvisitador] = true;
            }
                this.comprobarChats();
            }
            this.loading = false;
        },
        async eliminarvisita(visita){
            //Las citas enviadas por interpwgs necesitan motivo de anulacion
            if(visita.interpwgs == 1){
                const fecha = visita.visita.fecha.split('-');
                this.visitaEliminar = visita;
                this.motivoEliminar = '';
                this.errorMotivoEliminar = false;
                this.textoVisitaEliminar = fecha[2] + '/' + fecha[1] + '/' + fecha[0] + ' ' + visita.visita.hora.substring(0,5) + ' - ' + visita.visita.nombre_operario;
                this.mostrarMotivoEliminar = true;
                return;
            }

            this.$confirm.require({
                message: '¿Seguro que quieres eliminar la visita?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: async() => {
                    const api = new PwgsApi();
                    try {
                        await api.delete('planning-pwgs/' + this.$props.id + '/eliminar-visita/' + visita.visita.idvisitador);
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    }finally{
                        this.obtenerVisitas(this.$props.id);
                    }
                },
                reject: () => {
                    return;
                }
            });
            
        },
        async eliminarVisitaMotivo(){
            if(!this.motivoEliminar.trim()){
                this.errorMotivoEliminar = true;
                return;
            }
            const api = new PwgsApi();
            try {
                await api.deletebody('planning-pwgs/' + this.$props.id + '/eliminar-visita/' + this.visitaEliminar.visita.idvisitador, { motivo: this.motivoEliminar }, {});
                this.mostrarMotivoEliminar = false;
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }finally{
                this.obtenerVisitas(this.$props.id);
            }
        },
        mapf(visita){
            var mapfreUrl=[visita.fichas_operario.completa_MAPFRE];
            //let urlglobal = localStorage.getItem('direccion');
            window.open(mapfreUrl, "Mapfre", "width=800, height=600");
        },
        multi1(visita){
            var ms = visita.fichas_operario.completa_MULTIASISTENCIA_WS[0]
            //let urlglobal = localStorage.getItem('direccion');
            window.open(ms, "Multiasistencia", "width=800, height=600");
        },
        multi2(visita){
            var ms = visita.fichas_operario.completa_MULTIASISTENCIA_WS[1]
           // let urlglobal = localStorage.getItem('direccion');
            window.open(ms, "Multiasistencia", "width=800, height=600");
        },
        multi3(visita){
            var ms = visita.fichas_operario.completa_MULTIASISTENCIA_WS[2]
            //let urlglobal = localStorage.getItem('direccion');
            window.open(ms, "Multiasistencia", "width=800, height=600");
        },
        toggle(event, visita) {
            this.cargarvisita(visita);
            this.$refs.op.toggle(event);
        },
        closeToggle() {
            this.$refs.op.hide();
        },
        cargarvisita(visita) {
            if(visita.archivos.length > 15){
                visita.archivosprev = visita.archivos.slice(0, 15);
                this.prevcortada = true;
            }else{
                visita.archivosprev = visita.archivos;
                this.prevcortada = false;
            }
            this.visitaamostrar = visita;
        },
        infoevento(event, texto) {
            this.infoamostrar = texto;
            this.$refs.opdos.toggle(event);
        },
        closeInfo() {
            this.$refs.opdos.hide();
        },
        async obtenerdocumentosvisitas() {
            const aux = this.servicio;
            this.documentosvisitas = aux.documentos.visitas;
            this.documentosreclamacion = aux.documentos.reclamacion;
        },
        formato(texto) {
            return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
        },
        abrirventana(visita) {
            var url = visita.fichas_operario.completa_generico;
          //  let urlglobal = localStorage.getItem('direccion');
            window.open(url, "Parte genérico", "width=800, height=600");
        },
    },
    mounted(){
        this.visitas = [];
        this.comprobarSe();
        if(this.servicio){
            this.obtenerVisitas(this.$props.id);
            this.obtenerdocumentosvisitas();
        }
        this.urlglobal = localStorage.getItem("direccion");
    },
    watch: {
        servicio(){
            this.obtenerVisitas(this.$props.id);
            this.obtenerdocumentosvisitas();
        },
        id(){
            this.loading=true;
        },
        cargaseccion() {
            
            this.visitas = [];
            this.comprobarSe();
            if (this.servicio) {
                this.obtenerVisitas(this.$props.id);
                this.obtenerdocumentosvisitas();
            }
                this.urlglobal = localStorage.getItem("direccion");
            

         }
    }
};
</script>
<style>
/* ConfirmDialog por encima de cualquier otro diálogo */
.p-confirm-dialog { z-index: 100010 !important; }
.p-dialog-mask:has(.p-confirm-dialog) { z-index: 100009 !important; }
</style>
